module.exports = __webpack_public_path__ + "img/loan-providers.4b378f6.webp";